export default function AffiliateColoredIcon({ ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        fill="#FFC107"
        d="M12.5 0a.5.5 0 00-.5.5v10.988a.5.5 0 00.5.5h10.988a.5.5 0 00.5-.5C23.98 5.146 18.84.008 12.498 0z"
      />
      <path
        fill="#2196F3"
        d="M17.889 21.17L11 12.316V1.498a.5.5 0 00-.5-.5C4.718.999.014 6.153.014 12.488.02 18.828 5.159 23.967 11.5 23.974a8.533 8.533 0 006.31-2.111.5.5 0 00.079-.693z"
      />
      <path
        fill="#4CAF50"
        d="M23.488 12.986h-9.99a.5.5 0 00-.388.813l6.493 8.039a.5.5 0 00.353.184h.035a.5.5 0 00.341-.133 11.531 11.531 0 003.655-8.403.5.5 0 00-.5-.5z"
      />
    </svg>
  );
}
